import { render, staticRenderFns } from "./ProjectSegments.vue?vue&type=template&id=11ed894f&"
import script from "./ProjectSegments.vue?vue&type=script&lang=js&"
export * from "./ProjectSegments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports